import classnames from "classnames";
import { RichText } from "prismic-reactjs";
import React from "react";
import { IRichText } from "src/types/prismic";

interface IProps {
  className?: string;
  render?: IRichText[];
}

export const RichTextBlock = ({
  className,
  render,
}: IProps): JSX.Element | null => {
  const isEmpty =
    !render ||
    render?.filter(({ text }) => text !== (null || undefined || "")).length ===
      0;

  if (isEmpty) {
    return null;
  }

  return (
    <div className={classnames("block-text", className)}>
      <RichText render={render} />
    </div>
  );
};
